// GENERATED by scripts/content/generate-registry.mjs — do not edit by hand.
// Re-run that script after adding or removing a content file.
//
// This file IS the canonical-ID<->slug map: every PageEntry carries `id`,
// `locale` and `slug` together, so there is no separate table to keep in
// sync. A locale missing from an id's group means the page does not exist in
// that locale — absence is the signal, there is no "unavailable" sentinel.
import type { Locale } from "@/lib/locale";
import type { PageEntry } from "@/content/schema";
import { p17DeutscheNachhaltigkeitspreisDE } from "./article/17-deutsche-nachhaltigkeitspreis.de";
import { p3dDruckDE } from "./article/3d-druck.de";
import { p3dPrintingEN } from "./article/3d-printing.en";
import { p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg222DE } from "./article/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2-2-2.de";
import { p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg22DE } from "./article/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2-2.de";
import { p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg2DE } from "./article/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2.de";
import { p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburgDE } from "./article/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg.de";
import { aktionHerzensretterDE } from "./article/aktion-herzensretter.de";
import { allesWasSieUeberDieBerechnungVonFedernWissenMuessenDE } from "./article/alles-was-sie-ueber-die-berechnung-von-federn-wissen-muessen.de";
import { allesWasSieUeberDieFederpruefungWissenMuessenDE } from "./article/alles-was-sie-ueber-die-federpruefung-wissen-muessen.de";
import { allesWasSieUeberFederabmessungenWissenMuessenDE } from "./article/alles-was-sie-ueber-federabmessungen-wissen-muessen.de";
import { allesWasSieUeberFedernormenWissenMuessenDE } from "./article/alles-was-sie-ueber-federnormen-wissen-muessen.de";
import { allesWasSieUeberFederratenWissenMuessenDE } from "./article/alles-was-sie-ueber-federraten-wissen-muessen.de";
import { allesWasSieUeberFedertypenWissenMuessenDE } from "./article/alles-was-sie-ueber-federtypen-wissen-muessen.de";
import { ausbildungUndNachwuchsleistungssportJuliusSieglerImPortraetDE } from "./article/ausbildung-und-nachwuchsleistungssport-julius-siegler-im-portraet.de";
import { ausbildungZumElektronikerMWDDE } from "./article/ausbildung-zum-elektroniker-m-w-d.de";
import { ausbildungZumFachlageristMWDDE } from "./article/ausbildung-zum-fachlagerist-m-w-d.de";
import { ausbildungZumIndustriekaufmannFrauMWDDE } from "./article/ausbildung-zum-industriekaufmann-frau-m-w-d.de";
import { ausbildungZumIndustriemechanikerWerkzeugmechanikerMWDDE } from "./article/ausbildung-zum-industriemechaniker-werkzeugmechaniker-m-w-d.de";
import { ausbildungZumTechnischenProduktdesignerDE } from "./article/ausbildung-zum-technischen-produktdesigner.de";
import { ausbildungZumZurMaschinenAnlagenfuehrerInDE } from "./article/ausbildung-zum-zur-maschinen-anlagenfuehrer-in.de";
import { ausbildungZurFachkraftFuerLagerlogistikMWDDE } from "./article/ausbildung-zur-fachkraft-fuer-lagerlogistik-m-w-d.de";
import { ausbildung2023DE } from "./article/ausbildung2023.de";
import { ausbildungsstart2021DE } from "./article/ausbildungsstart-2021.de";
import { ausbildungsstart20222DE } from "./article/ausbildungsstart-2022-2.de";
import { automobilfedernherstellerDE } from "./article/automobilfedernhersteller.de";
import { automotiveSpringManufacturerEN } from "./article/automotive-spring-manufacturer.en";
import { azubiEventOktober20222DE } from "./article/azubi-event-oktober-2022-2.de";
import { azubiEventOktober2022DE } from "./article/azubi-event-oktober-2022.de";
import { azubiSeminarInFuersteneckDE } from "./article/azubi-seminar-in-fuersteneck.de";
import { baufortschrittInSonnebergDE } from "./article/baufortschritt-in-sonneberg.de";
import { bedeutungFedervorspannungOptimaleLeistungDE } from "./article/bedeutung-federvorspannung-optimale-leistung.de";
import { beispielEinbauSchenkelfederDE } from "./article/beispiel-einbau-schenkelfeder.de";
import { blogDE } from "./article/blog.de";
import { blogEN } from "./article/blog.en";
import { branchenAutomotiveDE } from "./article/branchen--automotive.de";
import { branchenElektrotechnikDE } from "./article/branchen--elektrotechnik.de";
import { branchenMedizintechnikDE } from "./article/branchen--medizintechnik.de";
import { branchenWeisseWareDE } from "./article/branchen--weisse-ware.de";
import { branchenWeitereBranchenDE } from "./article/branchen--weitere-branchen.de";
import { branchenDE } from "./article/branchen.de";
import { careersEN } from "./article/careers.en";
import { cncDrahtbiegeteileDE } from "./article/cnc-drahtbiegeteile.de";
import { cncFraesenPrototypenbauDE } from "./article/cnc-fraesen-prototypenbau.de";
import { cncMillingPrototypeConstructionEN } from "./article/cnc-milling-prototype-construction.en";
import { cncPrototypenbauDE } from "./article/cnc-prototypenbau.de";
import { cncPrototypingEN } from "./article/cnc-prototyping.en";
import { cncWireBendingPartsEN } from "./article/cnc-wire-bending-parts.en";
import { coilSpringEN } from "./article/coil-spring.en";
import { coilSpringsForVehiclesEN } from "./article/coil-springs-for-vehicles.en";
import { compressionCoilSpringsEN } from "./article/compression-coil-springs.en";
import { compressionSpringManufacturerEN } from "./article/compression-spring-manufacturer.en";
import { compressionSpringsDin2095EN } from "./article/compression-springs-din-2095.en";
import { compressionSpringsDinIso10243EN } from "./article/compression-springs-din-iso-10243.en";
import { compressionSpringsWithScrewThreadEN } from "./article/compression-springs-with-screw-thread.en";
import { conicalCompressionSpringsEN } from "./article/conical-compression-springs.en";
import { cookieRichtlinieEuDE } from "./article/cookie-richtlinie-eu.de";
import { coolBleibenBeiHeissenTemperaturenDE } from "./article/cool-bleiben-bei-heissen-temperaturen.de";
import { costOfPrototypeSuspensionEN } from "./article/cost-of-prototype-suspension.en";
import { customMadeSpringsOfTheHighestQualityEN } from "./article/custom-made-springs-of-the-highest-quality.en";
import { customTensionSpringsEN } from "./article/custom-tension-springs.en";
import { customisedCompressionSpringsEN } from "./article/customised-compression-springs.en";
import { customisedTensionSpringsMadeToMeasureEN } from "./article/customised-tension-springs-made-to-measure.en";
import { customizedDiscSpringsTheKeyToEfficientSpringSolutionsEN } from "./article/customized-disc-springs-the-key-to-efficient-spring-solutions.en";
import { customizedLeafSpringsForTheHighestDemandsInTheIndustryEN } from "./article/customized-leaf-springs-for-the-highest-demands-in-the-industry.en";
import { cylindricalHelicalCompressionEN } from "./article/cylindrical-helical-compression.en";
import { datenschutzerklaerungDE } from "./article/datenschutzerklaerung.de";
import { derBackCheckMitDerAokBayernDE } from "./article/der-back-check-mit-der-aok-bayern.de";
import { derRichtigeSchenkelfederherstellerDE } from "./article/der-richtige-schenkelfederhersteller.de";
import { derUltimativeLeitfadenEinsatzFederstahldrahtIndustrieDE } from "./article/der-ultimative-leitfaden-einsatz-federstahldraht-industrie.de";
import { detentSpringEN } from "./article/detent-spring.en";
import { developStampedBentPartsPrototypesEN } from "./article/develop-stamped-bent-parts-prototypes.en";
import { dieBedeutungDerFederbelastungsgrenzeDE } from "./article/die-bedeutung-der-federbelastungsgrenze.de";
import { dieBedeutungDerFederfestigkeitDE } from "./article/die-bedeutung-der-federfestigkeit.de";
import { dieBedeutungDerFederkonstanteInDerIndustrieDE } from "./article/die-bedeutung-der-federkonstante-in-der-industrie.de";
import { dieBedeutungDerFederlaengeFuerEineOptimaleLeistungDE } from "./article/die-bedeutung-der-federlaenge-fuer-eine-optimale-leistung.de";
import { dieBedeutungDerFedersteifigkeitFuerOptimaleLeistungUndEffizienzDE } from "./article/die-bedeutung-der-federsteifigkeit-fuer-optimale-leistung-und-effizienz.de";
import { dieBedeutungDerMusterentwicklungFuerIhrUnternehmenDE } from "./article/die-bedeutung-der-musterentwicklung-fuer-ihr-unternehmen.de";
import { dieBedeutungVonFederbelastungInDerIndustrieAllesWasSieWissenMuessenDE } from "./article/die-bedeutung-von-federbelastung-in-der-industrie-alles-was-sie-wissen-muessen.de";
import { dieBedeutungVonHandmusternInDerB2bBrancheDE } from "./article/die-bedeutung-von-handmustern-in-der-b2b-branche.de";
import { dieBedeutungVonMusterteilenFuerIhrUnternehmenSoOptimierenSieIhreProduktentwicklungDE } from "./article/die-bedeutung-von-musterteilen-fuer-ihr-unternehmen-so-optimieren-sie-ihre-produktentwicklung.de";
import { dieBedeutungVonPraezisionsfedernInDerIndustrieDE } from "./article/die-bedeutung-von-praezisionsfedern-in-der-industrie.de";
import { dieGeheimnisseDerFedercharakteristikSoFindenSieDiePerfekteFederFuerIhrUnternehmenDE } from "./article/die-geheimnisse-der-federcharakteristik-so-finden-sie-die-perfekte-feder-fuer-ihr-unternehmen.de";
import { dieKraftDerFedernAllesWasSieUeberFederkraftWissenMuessenDE } from "./article/die-kraft-der-federn-alles-was-sie-ueber-federkraft-wissen-muessen.de";
import { dieKunstDerFederherstellungDE } from "./article/die-kunst-der-federherstellung.de";
import { dieKunstDerMustererstellungSoOptimierenSieIhreProduktentwicklungDE } from "./article/die-kunst-der-mustererstellung-so-optimieren-sie-ihre-produktentwicklung.de";
import { dieKunstDesFederdesignsPerfekteLoesungenFuerIhreAnforderungenDE } from "./article/die-kunst-des-federdesigns-perfekte-loesungen-fuer-ihre-anforderungen.de";
import { dieMagieDesFedergeraeuschsWieEsIhreProduktivitaetSteigernKannDE } from "./article/die-magie-des-federgeraeuschs-wie-es-ihre-produktivitaet-steigern-kann.de";
import { diePerfekteBalanceAllesWasSieUeberFederungssystemeWissenMuessenDE } from "./article/die-perfekte-balance-alles-was-sie-ueber-federungssysteme-wissen-muessen.de";
import { diePerfekteLoesungFuerEineEffizienteFedermontageDE } from "./article/die-perfekte-loesung-fuer-eine-effiziente-federmontage.de";
import { diePerfekteLoesungFuerEineReibungsloseMontageAllesWasSieUeberRastfedernWissenMuessenDE } from "./article/die-perfekte-loesung-fuer-eine-reibungslose-montage-alles-was-sie-ueber-rastfedern-wissen-muessen.de";
import { diePerfekteLoesungFuerEineReibungsloseMontageDieHuelsenfederDE } from "./article/die-perfekte-loesung-fuer-eine-reibungslose-montage-die-huelsenfeder.de";
import { diePerfekteLoesungFuerPraeziseUndZuverlaessigeKraftuebertragungStoeselMitFederDE } from "./article/die-perfekte-loesung-fuer-praezise-und-zuverlaessige-kraftuebertragung-stoesel-mit-feder.de";
import { diePerfekteMusterkonstruktionFuerIhrenErfolgDE } from "./article/die-perfekte-musterkonstruktion-fuer-ihren-erfolg.de";
import { diePerfekteSchraubenfederFuerHoechsteAnspruecheInDerIndustrieDE } from "./article/die-perfekte-schraubenfeder-fuer-hoechste-ansprueche-in-der-industrie.de";
import { dieUnsichtbarenHeldenAllesWasSieUeberFedermechanismenWissenMuessenDE } from "./article/die-unsichtbaren-helden-alles-was-sie-ueber-federmechanismen-wissen-muessen.de";
import { dieVielseitigkeitVonFederwerkstoffenDE } from "./article/die-vielseitigkeit-von-federwerkstoffen.de";
import { dieVorteileEinerHochwertigenFederbeschichtungDE } from "./article/die-vorteile-einer-hochwertigen-federbeschichtung.de";
import { dieZukunftDerFertigungAllesWasSieUeberDen3dDruckWissenMuessenDE } from "./article/die-zukunft-der-fertigung-alles-was-sie-ueber-den-3d-druck-wissen-muessen.de";
import { dietzErweitertSeineProduktionNasenbuegelFuerSchutzmasken2DE } from "./article/dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken-2.de";
import { dietzErweitertSeineProduktionNasenbuegelFuerSchutzmaskenDE } from "./article/dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken.de";
import { dietzGmbhErneutFuerDeutschenNachhaltigkeitspreisNominiertDE } from "./article/dietz-gmbh-erneut-fuer-deutschen-nachhaltigkeitspreis-nominiert.de";
import { dietzGmbhImSpotlightUnserEngagementFuerDenKlimaschutzDE } from "./article/dietz-gmbh-im-spotlight-unser-engagement-fuer-den-klimaschutz.de";
import { dietzGmbhUnterDerRubrikCoburgsBesteNeuImCoburgerMagazinDE } from "./article/dietz-gmbh-unter-der-rubrik-coburgs-beste-neu-im-coburger-magazin.de";
import { dietzJubilarfeier22DE } from "./article/dietz-jubilarfeier-2-2.de";
import { dietzJubilarfeier2DE } from "./article/dietz-jubilarfeier-2.de";
import { dietzJubilarfeierDE } from "./article/dietz-jubilarfeier.de";
import { dietzMitarbeiterGewinnenHsc2000CoburgTicketsDE } from "./article/dietz-mitarbeiter-gewinnen-hsc-2000-coburg-tickets.de";
import { dietzSagtHalloBeiLinkedinUndXing2DE } from "./article/dietz-sagt-hallo-bei-linkedin-und-xing-2.de";
import { dietzSagtHalloBeiLinkedinUndXingDE } from "./article/dietz-sagt-hallo-bei-linkedin-und-xing.de";
import { discSpringManufacturersEN } from "./article/disc-spring-manufacturers.en";
import { doppelschenkelfedernMechanischeSystemeDE } from "./article/doppelschenkelfedern-mechanische-systeme.de";
import { doubleLegSpringsEN } from "./article/double-leg-springs.en";
import { downloadsDE } from "./article/downloads.de";
import { downloadsEN } from "./article/downloads.en";
import { drahtbiegeteileAusEdelstahlDE } from "./article/drahtbiegeteile-aus-edelstahl.de";
import { drahtbiegeteileHerstellerDE } from "./article/drahtbiegeteile-hersteller.de";
import { drahtbiegeteileInKleinserieDE } from "./article/drahtbiegeteile-in-kleinserie.de";
import { dreifachNominiertUndJetztFinalistDE } from "./article/dreifach-nominiert-und-jetzt-finalist.de";
import { druckfederherstellerDE } from "./article/druckfederhersteller.de";
import { druckfedernMitSchraubgewindeDE } from "./article/druckfedern-mit-schraubgewinde.de";
import { druckfedernNachDin2095DE } from "./article/druckfedern-nach-din-2095.de";
import { druckfedernNachDinIso10243DE } from "./article/druckfedern-nach-din-iso-10243.de";
import { ecovadisBronzeMedailleDE } from "./article/ecovadis-bronze-medaille.de";
import { edelstahlDruckfedernDE } from "./article/edelstahl-druckfedern.de";
import { edelstahlKompressionsfedernDE } from "./article/edelstahl-kompressionsfedern.de";
import { edelstahlZugfedernDE } from "./article/edelstahl-zugfedern.de";
import { effectiveSolutionsForReducingSpringFrictionInTheIndustryEN } from "./article/effective-solutions-for-reducing-spring-friction-in-the-industry.en";
import { effektiveLoesungenReduzierungFederreibungIndustrieDE } from "./article/effektive-loesungen-reduzierung-federreibung-industrie.de";
import { efficientSpringInstallationHowToOptimizeYourProductionProcessesEN } from "./article/efficient-spring-installation-how-to-optimize-your-production-processes.en";
import { effizienteFederinstallationOptimierenProduktionsprozesseDE } from "./article/effiziente-federinstallation-optimieren-produktionsprozesse.de";
import { einmalZumNordkapUndZurueckDE } from "./article/einmal-zum-nordkap-und-zurueck.de";
import { electronica2018DE } from "./article/electronica-2018.de";
import { elektronikerMWDDE } from "./article/elektroniker-m-w-d.de";
import { enterpriseBusinessPolicyEN } from "./article/enterprise--business-policy.en";
import { enterprisePartnerEN } from "./article/enterprise--partner.en";
import { enterprisePerformancesLogisticsEN } from "./article/enterprise--performances--logistics.en";
import { enterprisePerformancesMaterialEN } from "./article/enterprise--performances--material.en";
import { enterprisePerformancesProductionEN } from "./article/enterprise--performances--production.en";
import { enterprisePerformancesQualityEN } from "./article/enterprise--performances--quality.en";
import { enterprisePerformancesEN } from "./article/enterprise--performances.en";
import { enterpriseSustainabilityEN } from "./article/enterprise--sustainability.en";
import { enterpriseEN } from "./article/enterprise.en";
import { ersteDietzUmweltwocheDE } from "./article/erste-dietz-umweltwoche.de";
import { europassVerleihungDietzAzubisAlsAusbildungsbotschafterDE } from "./article/europass-verleihung-dietz-azubis-als-ausbildungsbotschafter.de";
import { everythingYouNeedToKnowAboutCalculatingSpringsEN } from "./article/everything-you-need-to-know-about-calculating-springs.en";
import { everythingYouNeedToKnowAboutSpringDimensionsEN } from "./article/everything-you-need-to-know-about-spring-dimensions.en";
import { everythingYouNeedToKnowAboutSpringRatesEN } from "./article/everything-you-need-to-know-about-spring-rates.en";
import { everythingYouNeedToKnowAboutSpringStandardsEN } from "./article/everything-you-need-to-know-about-spring-standards.en";
import { everythingYouNeedToKnowAboutSpringTypesEN } from "./article/everything-you-need-to-know-about-spring-types.en";
import { everythingYouNeedToKnowAboutTheSpringTestEN } from "./article/everything-you-need-to-know-about-the-spring-test.en";
import { extensionSpringsWithCoiledHookEN } from "./article/extension-springs-with-coiled-hook.en";
import { extensionSpringsWithEyeletEN } from "./article/extension-springs-with-eyelet.en";
import { fabrikImSeminarraum2DE } from "./article/fabrik-im-seminarraum-2.de";
import { fabrikImSeminarraumDE } from "./article/fabrik-im-seminarraum.de";
import { federabmessungenDE } from "./article/federabmessungen.de";
import { federbeanspruchungDE } from "./article/federbeanspruchung.de";
import { federbelastungDE } from "./article/federbelastung.de";
import { federbelastungsgrenzeDE } from "./article/federbelastungsgrenze.de";
import { federberechnungDE } from "./article/federberechnung.de";
import { federbeschichtungDE } from "./article/federbeschichtung.de";
import { federcharakteristikDE } from "./article/federcharakteristik.de";
import { federdesignDE } from "./article/federdesign.de";
import { federfestigkeitDE } from "./article/federfestigkeit.de";
import { federgeraeuschDE } from "./article/federgeraeusch.de";
import { federherstellungDE } from "./article/federherstellung.de";
import { federherstellungstechnikenDE } from "./article/federherstellungstechniken.de";
import { federinstallationDE } from "./article/federinstallation.de";
import { federkennzeichnungDE } from "./article/federkennzeichnung.de";
import { federkennzeichnungenDE } from "./article/federkennzeichnungen.de";
import { federkonstanteDE } from "./article/federkonstante.de";
import { federkraftDE } from "./article/federkraft.de";
import { federlaengeDE } from "./article/federlaenge.de";
import { federmaterialDE } from "./article/federmaterial.de";
import { federmechanismenDE } from "./article/federmechanismen.de";
import { federmontageDE } from "./article/federmontage.de";
import { federnFuerTechnikDieOptimaleLoesungFuerTechnischeAnwendungenDE } from "./article/federn-fuer-technik-die-optimale-loesung-fuer-technische-anwendungen.de";
import { federnHerstellerDE } from "./article/federn-hersteller.de";
import { federnInDerMedizintechnikDE } from "./article/federn-in-der-medizintechnik.de";
import { federnfabrikDietzGmbhUnterDenNominiertenDE } from "./article/federnfabrik-dietz-gmbh-unter-den-nominierten.de";
import { federnormenDE } from "./article/federnormen.de";
import { federntechnikDE } from "./article/federntechnik.de";
import { federpruefungDE } from "./article/federpruefung.de";
import { federrateDE } from "./article/federrate.de";
import { federreibungDE } from "./article/federreibung.de";
import { federstahldrahtDE } from "./article/federstahldraht.de";
import { federsteifigkeitDE } from "./article/federsteifigkeit.de";
import { federtypenDE } from "./article/federtypen.de";
import { federungssystemeDE } from "./article/federungssysteme.de";
import { federvorspannungDE } from "./article/federvorspannung.de";
import { federwerkstoffDE } from "./article/federwerkstoff.de";
import { federwerkstoffeDE } from "./article/federwerkstoffe.de";
import { federwindeautomatenDE } from "./article/federwindeautomaten.de";
import { findLeafSpringsManufacturersEN } from "./article/find-leaf-springs-manufacturers.en";
import { findTheRightCompressionSpringManufacturerEN } from "./article/find-the-right-compression-spring-manufacturer.en";
import { findenSieHerstellerVonBlattfedernDE } from "./article/finden-sie-hersteller-von-blattfedern.de";
import { firmenstandortSonnebergStartschussFaelltMitKundenfreigabe2DE } from "./article/firmenstandort-sonneberg-startschuss-faellt-mit-kundenfreigabe-2.de";
import { firmenstandortSonnebergStartschussFaelltMitKundenfreigabeDE } from "./article/firmenstandort-sonneberg-startschuss-faellt-mit-kundenfreigabe.de";
import { flachdrahtDruckfedernDE } from "./article/flachdraht-druckfedern.de";
import { flachdrahtWellenfedernDE } from "./article/flachdraht-wellenfedern.de";
import { flacheDruckfedernDE } from "./article/flache-druckfedern.de";
import { flatCompressionSpringsEN } from "./article/flat-compression-springs.en";
import { flatWireCompressionSpringsEN } from "./article/flat-wire-compression-springs.en";
import { flatWireWaveSpringsEN } from "./article/flat-wire-wave-springs.en";
import { flexibilitaetUndQualitaetFedernNachMassIndividuellAngefertigtFuerIhrUnternehmenDE } from "./article/flexibilitaet-und-qualitaet-federn-nach-mass-individuell-angefertigt-fuer-ihr-unternehmen.de";
import { followUsOnInstagram222DE } from "./article/follow-us-on-instagram-2-2-2.de";
import { followUsOnInstagram22DE } from "./article/follow-us-on-instagram-2-2.de";
import { followUsOnInstagram2DE } from "./article/follow-us-on-instagram-2.de";
import { followUsOnInstagramDE } from "./article/follow-us-on-instagram.de";
import { garageDoorSpringsEN } from "./article/garage-door-springs.en";
import { glossarDE } from "./article/glossar.de";
import { glossaryEN } from "./article/glossary.en";
import { halterungenFuerWellenfedernDE } from "./article/halterungen-fuer-wellenfedern.de";
import { handPatternsEN } from "./article/hand-patterns.en";
import { handmusterDE } from "./article/handmuster.de";
import { herstellerFuerDruckfedernDE } from "./article/hersteller-fuer-druckfedern.de";
import { herzlichenGlueckwunschZurBerufsausbildungDE } from "./article/herzlichen-glueckwunsch-zur-berufsausbildung.de";
import { hightechlive2DE } from "./article/hightechlive-2.de";
import { hightechliveDE } from "./article/hightechlive.de";
import { hinweisgebersystemDE } from "./article/hinweisgebersystem.de";
import { howDoesACoilSpringMachineWorkEN } from "./article/how-does-a-coil-spring-machine-work.en";
import { huelsenfederDE } from "./article/huelsenfeder.de";
import { impressumDE } from "./article/impressum.de";
import { imprintEN } from "./article/imprint.en";
import { industrie40DE } from "./article/industrie-4-0.de";
import { industriesAutomotiveEN } from "./article/industries--automotive.en";
import { industriesElectricalEngineeringEN } from "./article/industries--electrical-engineering.en";
import { industriesMedicalEN } from "./article/industries--medical.en";
import { industriesOtherIndustriesEN } from "./article/industries--other-industries.en";
import { industriesWhiteGoodsEN } from "./article/industries--white-goods.en";
import { industriesEN } from "./article/industries.en";
import { infosZurAktuellenLageDE } from "./article/infos-zur-aktuellen-lage.de";
import { installationOfATorsionSpringEN } from "./article/installation-of-a-torsion-spring.en";
import { integrationDurchArbeitWirtschaftsministerinAignerZeichnetFirmenAusDE } from "./article/integration-durch-arbeit-wirtschaftsministerin-aigner-zeichnet-firmen-aus.de";
import { karriereAusbildungDE } from "./article/karriere--ausbildung.de";
import { karriereDualesStudiumDE } from "./article/karriere--duales-studium.de";
import { karriereFachkraefteDE } from "./article/karriere--fachkraefte.de";
import { karriereInitativbewerbungDE } from "./article/karriere--initativbewerbung.de";
import { karrierePraktikumDE } from "./article/karriere--praktikum.de";
import { karriereDE } from "./article/karriere.de";
import { kleineDruckfedernDE } from "./article/kleine-druckfedern.de";
import { kleineTorsionsfedernDE } from "./article/kleine-torsionsfedern.de";
import { kleineZugfedernDE } from "./article/kleine-zugfedern.de";
import { konischeDruckfedernDE } from "./article/konische-druckfedern.de";
import { konstantkraftfedernDE } from "./article/konstantkraftfedern.de";
import { kostenPrototypenfederungenDE } from "./article/kosten-prototypenfederungen.de";
import { kunststoffteileMaschinenbauDE } from "./article/kunststoffteile-maschinenbau.de";
import { leitfadenSchraubendruckfedernDE } from "./article/leitfaden-schraubendruckfedern.de";
import { maschineneinrichterStanzUmformtechnikMWDDE } from "./article/maschineneinrichter-stanz-umformtechnik-m-w-d.de";
import { massgefertigteBlattfedernHoechsteAnspruecheIndustrieDE } from "./article/massgefertigte-blattfedern-hoechste-ansprueche-industrie.de";
import { massgefertigteDruckfedernDE } from "./article/massgefertigte-druckfedern.de";
import { massgefertigteFedernDE } from "./article/massgefertigte-federn.de";
import { massgeschneiderteTellerfedernEffizienteZuverlaessigeFederloesungenDE } from "./article/massgeschneiderte-tellerfedern-effiziente-zuverlaessige-federloesungen.de";
import { meaningOfSpringMarkingsEN } from "./article/meaning-of-spring-markings.en";
import { mehrAlsNurFedernDE } from "./article/mehr-als-nur-federn.de";
import { metalPrintingEN } from "./article/metal-printing.en";
import { metalPrototypingEN } from "./article/metal-prototyping.en";
import { metalldruckDE } from "./article/metalldruck.de";
import { mitarbeiterfestDerDietzGmbhDE } from "./article/mitarbeiterfest-der-dietz-gmbh.de";
import { mountsForWaveSpringsEN } from "./article/mounts-for-wave-springs.en";
import { musterbauProduktentwicklungDE } from "./article/musterbau-produktentwicklung.de";
import { musterdesignDE } from "./article/musterdesign.de";
import { musterentwicklungDE } from "./article/musterentwicklung.de";
import { mustererstellungDE } from "./article/mustererstellung.de";
import { musterkonstruktionDE } from "./article/musterkonstruktion.de";
import { musterteileDE } from "./article/musterteile.de";
import { necazubi2025AusbildungsmesseDE } from "./article/necazubi-2025-ausbildungsmesse.de";
import { necazubi2026DeineChanceAufDenTraumAusbildungsplatzDE } from "./article/necazubi-2026-deine-chance-auf-den-traum-ausbildungsplatz.de";
import { neueAuszubildendeInFuersteneckDE } from "./article/neue-auszubildende-in-fuersteneck.de";
import { neueHalleInSonnebergUmzugUnsererMontagetechnikDE } from "./article/neue-halle-in-sonneberg-umzug-unserer-montagetechnik.de";
import { neustadtHilftDE } from "./article/neustadt-hilft.de";
import { newsDE } from "./article/news.de";
import { optimalSpringLoadingHowToMaximizeThePerformanceOfYourMachinesEN } from "./article/optimal-spring-loading-how-to-maximize-the-performance-of-your-machines.en";
import { optimaleFederbeanspruchungWieSieDieLeistungIhrerMaschinenMaximierenDE } from "./article/optimale-federbeanspruchung-wie-sie-die-leistung-ihrer-maschinen-maximieren.de";
import { performanceCoilSpringsEN } from "./article/performance-coil-springs.en";
import { plasticPartsInMechanicalEngineeringEN } from "./article/plastic-parts-in-mechanical-engineering.en";
import { plasticPrototypingEN } from "./article/plastic-prototyping.en";
import { plasticSpringManufacturersAComprehensiveOverviewEN } from "./article/plastic-spring-manufacturers-a-comprehensive-overview.en";
import { plastikfedernHerstellerDE } from "./article/plastikfedern-hersteller.de";
import { plungerWithSpringEN } from "./article/plunger-with-spring.en";
import { praktikumBeiDerDietzGmbhDE } from "./article/praktikum-bei-der-dietz-gmbh.de";
import { privacyPolicyEN } from "./article/privacy-policy.en";
import { produceStampedBentPartsInSmallSeriesEN } from "./article/produce-stamped-bent-parts-in-small-series.en";
import { productionOfBentWirePartsInSmallSeriesEN } from "./article/production-of-bent-wire-parts-in-small-series.en";
import { productsEN } from "./article/products.en";
import { produkteDE } from "./article/produkte.de";
import { produktionTechnischeKunststoffteileDE } from "./article/produktion-technische-kunststoffteile.de";
import { prototypeConstructionSupplierEN } from "./article/prototype-construction-supplier.en";
import { prototypeConstructionEN } from "./article/prototype-construction.en";
import { prototypeHousingEN } from "./article/prototype-housing.en";
import { prototypenbauAusKunststoffDE } from "./article/prototypenbau-aus-kunststoff.de";
import { prototypenbauAusMetallDE } from "./article/prototypenbau-aus-metall.de";
import { prototypenbauInDerMedizintechnikDE } from "./article/prototypenbau-in-der-medizintechnik.de";
import { prototypenbauLieferantenDE } from "./article/prototypenbau-lieferanten.de";
import { prototypenbauMit3dDruckDE } from "./article/prototypenbau-mit-3d-druck.de";
import { prototypgehaeuseDE } from "./article/prototypgehaeuse.de";
import { prototypingExplainedEN } from "./article/prototyping-explained.en";
import { prototypingInMedicalTechnologyEN } from "./article/prototyping-in-medical-technology.en";
import { prototypingProductDevelopmentEN } from "./article/prototyping-product-development.en";
import { prototypingWith3dPrintingEN } from "./article/prototyping-with-3d-printing.en";
import { rastfederDE } from "./article/rastfeder.de";
import { reinigungskraftMwdMitLeidenschaftFuerOrdnungDE } from "./article/reinigungskraft-mwd-mit-leidenschaft-fuer-ordnung.de";
import { resourcesEN } from "./article/resources.en";
import { sampleDesignEN } from "./article/sample-design.en";
import { sampleDevelopmentEN } from "./article/sample-development.en";
import { samplePartsEN } from "./article/sample-parts.en";
import { saveTheDateNecazubiAusbildungsmesseDE } from "./article/save-the-date-necazubi-ausbildungsmesse.de";
import { schenkelfederherstellerDE } from "./article/schenkelfederhersteller.de";
import { schenkelfedermaschineFmu08DE } from "./article/schenkelfedermaschine-fmu-08.de";
import { schoolMeetsWorkDE } from "./article/school-meets-work.de";
import { schraubenfederDE } from "./article/schraubenfeder.de";
import { sleeveSpringEN } from "./article/sleeve-spring.en";
import { smallCompressionSpringsEN } from "./article/small-compression-springs.en";
import { smallTensionSpringsEN } from "./article/small-tension-springs.en";
import { smallTorsionSpringsEN } from "./article/small-torsion-springs.en";
import { spannfederDE } from "./article/spannfeder.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg22DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2-2.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg2DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-2.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg32DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-2.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg332DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3-2.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg33DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3-3.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburg3DE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg-3.de";
import { spendeFuerDieStiftungFuerKrebskrankeKinderCoburgDE } from "./article/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg.de";
import { spendenStattGeschenkeDE } from "./article/spenden-statt-geschenke.de";
import { spiralAndCompressionSpringsEN } from "./article/spiral-and-compression-springs.en";
import { spiralSpringManufacturerEN } from "./article/spiral-spring-manufacturer.en";
import { spiralfederherstellerDE } from "./article/spiralfederhersteller.de";
import { spiralfedernAnwendungenDE } from "./article/spiralfedern-anwendungen.de";
import { spiralfedernDruckfedernDE } from "./article/spiralfedern-druckfedern.de";
import { spiralfedernFuerFahrzeugeDE } from "./article/spiralfedern-fuer-fahrzeuge.de";
import { springAssemblyEN } from "./article/spring-assembly.en";
import { springCalculationEN } from "./article/spring-calculation.en";
import { springCharacteristicsEN } from "./article/spring-characteristics.en";
import { springCoatingEN } from "./article/spring-coating.en";
import { springCoilingMachinesEN } from "./article/spring-coiling-machines.en";
import { springConstantEN } from "./article/spring-constant.en";
import { springDesignEN } from "./article/spring-design.en";
import { springDimensionsEN } from "./article/spring-dimensions.en";
import { springForceEN } from "./article/spring-force.en";
import { springFrictionEN } from "./article/spring-friction.en";
import { springInstallationEN } from "./article/spring-installation.en";
import { springLabellingEN } from "./article/spring-labelling.en";
import { springLengthEN } from "./article/spring-length.en";
import { springLoadLimitEN } from "./article/spring-load-limit.en";
import { springLoadingEN } from "./article/spring-loading.en";
import { springManufacturerEN } from "./article/spring-manufacturer.en";
import { springManufacturingTechniquesExplainedEN } from "./article/spring-manufacturing-techniques-explained.en";
import { springManufacturingTechniquesEN } from "./article/spring-manufacturing-techniques.en";
import { springMaterial2EN } from "./article/spring-material-2.en";
import { springMaterialEN } from "./article/spring-material.en";
import { springMaterialsTheBigGuideEN } from "./article/spring-materials-the-big-guide.en";
import { springMechanismsEN } from "./article/spring-mechanisms.en";
import { springNoiseEN } from "./article/spring-noise.en";
import { springPreloadEN } from "./article/spring-preload.en";
import { springProductionEN } from "./article/spring-production.en";
import { springRateEN } from "./article/spring-rate.en";
import { springStandardsEN } from "./article/spring-standards.en";
import { springSteelWireEN } from "./article/spring-steel-wire.en";
import { springStiffnessEN } from "./article/spring-stiffness.en";
import { springStrengthEN } from "./article/spring-strength.en";
import { springStressEN } from "./article/spring-stress.en";
import { springTechnologyAnInnovativeSolutionEN } from "./article/spring-technology-an-innovative-solution.en";
import { springTestingEN } from "./article/spring-testing.en";
import { springTypesEN } from "./article/spring-types.en";
import { springsForTechnologyTheOptimalSolutionForTechnicalApplicationsEN } from "./article/springs-for-technology-the-optimal-solution-for-technical-applications.en";
import { springsInMedicalTechnologyEN } from "./article/springs-in-medical-technology.en";
import { stahlfederherstellerDE } from "./article/stahlfederhersteller.de";
import { stainlessSteelBentWirePartsEN } from "./article/stainless-steel-bent-wire-parts.en";
import { stainlessSteelCompressionSprings2EN } from "./article/stainless-steel-compression-springs-2.en";
import { stainlessSteelCompressionSpringsEN } from "./article/stainless-steel-compression-springs.en";
import { stainlessSteelTensionSprings2EN } from "./article/stainless-steel-tension-springs-2.en";
import { stainlessSteelTensionSpringsEN } from "./article/stainless-steel-tension-springs.en";
import { stampedAndBentPartsMadeFromSpringSteelEN } from "./article/stamped-and-bent-parts-made-from-spring-steel.en";
import { stampedAndBentPartsPerfectlyShapedAndPreciselyManufacturedEN } from "./article/stamped-and-bent-parts-perfectly-shaped-and-precisely-manufactured.en";
import { stampedAndFormedPartsSuppliersEN } from "./article/stamped-and-formed-parts-suppliers.en";
import { stampedBentPartsManufacturerEN } from "./article/stamped-bent-parts-manufacturer.en";
import { stanzUndBiegeteileAusFederstahlDE } from "./article/stanz-und-biegeteile-aus-federstahl.de";
import { stanzbiegeteileHerstellerDE } from "./article/stanzbiegeteile-hersteller.de";
import { stanzbiegeteileKleinserieDE } from "./article/stanzbiegeteile-kleinserie.de";
import { stanzbiegeteileLieferantenDE } from "./article/stanzbiegeteile-lieferanten.de";
import { stanzbiegeteilePrototypenDE } from "./article/stanzbiegeteile-prototypen.de";
import { stanzbiegeteileDE } from "./article/stanzbiegeteile.de";
import { starkeDruckfedernDE } from "./article/starke-druckfedern.de";
import { starkeZugfedernDE } from "./article/starke-zugfedern.de";
import { steelSpringManufacturerEN } from "./article/steel-spring-manufacturer.en";
import { stoesselMitFederDE } from "./article/stoessel-mit-feder.de";
import { strongCompressionSpringsEN } from "./article/strong-compression-springs.en";
import { strongTensionSpringsEN } from "./article/strong-tension-springs.en";
import { suspensionSystemsEN } from "./article/suspension-systems.en";
import { tailorMadeSpringsCustomizedForYourCompanyEN } from "./article/tailor-made-springs-customized-for-your-company.en";
import { technicalPlasticPartsEN } from "./article/technical-plastic-parts.en";
import { technicalSpringManufacturerEN } from "./article/technical-spring-manufacturer.en";
import { technicalSpringsProductionEN } from "./article/technical-springs-production.en";
import { technikenFederherstellungDE } from "./article/techniken-federherstellung.de";
import { technischeFedernHerstellerDE } from "./article/technische-federn-hersteller.de";
import { technischeFedernDE } from "./article/technische-federn.de";
import { technischeKunststoffteileUndMetallkomponentenVereint2DE } from "./article/technische-kunststoffteile-und-metallkomponenten-vereint-2.de";
import { tellerfedernHerstellerDE } from "./article/tellerfedern-hersteller.de";
import { tensionSpringManufacturerEN } from "./article/tension-spring-manufacturer.en";
import { tensionSpringEN } from "./article/tension-spring.en";
import { tensionSpringsAccordingToDin2098EN } from "./article/tension-springs-according-to-din-2098.en";
import { tensionSpringsForGarageDoorsEN } from "./article/tension-springs-for-garage-doors.en";
import { tensionSpringsWithEyeletsEN } from "./article/tension-springs-with-eyelets.en";
import { tensionSpringsWithHooksEN } from "./article/tension-springs-with-hooks.en";
import { tensionSpringsWithThreadedBoltsEN } from "./article/tension-springs-with-threaded-bolts.en";
import { tensionSpringsWithThreadedPlugsEN } from "./article/tension-springs-with-threaded-plugs.en";
import { theAdvantagesOfAHighQualitySpringCoatingForYourProductsEN } from "./article/the-advantages-of-a-high-quality-spring-coating-for-your-products.en";
import { theArtOfSampleCreationHowToOptimizeYourProductDevelopmentEN } from "./article/the-art-of-sample-creation-how-to-optimize-your-product-development.en";
import { theArtOfSpringDesignPerfectSolutionsForYourRequirementsEN } from "./article/the-art-of-spring-design-perfect-solutions-for-your-requirements.en";
import { theArtOfSpringProductionQualityAndPrecisionForYourSuccessEN } from "./article/the-art-of-spring-production-quality-and-precision-for-your-success.en";
import { theFutureOfManufacturingEverythingYouNeedToKnowAbout3dPrintingEN } from "./article/the-future-of-manufacturing-everything-you-need-to-know-about-3d-printing.en";
import { theImportanceOfHandSamplesInTheB2bSectorWhyTheyAreIndispensableEN } from "./article/the-importance-of-hand-samples-in-the-b2b-sector-why-they-are-indispensable.en";
import { theImportanceOfPatternDevelopmentForYourCompanyEN } from "./article/the-importance-of-pattern-development-for-your-company.en";
import { theImportanceOfPrecisionSpringsInTheIndustryEN } from "./article/the-importance-of-precision-springs-in-the-industry.en";
import { theImportanceOfSamplePartsForYourCompanyHowToOptimizeYourProductDevelopmentEN } from "./article/the-importance-of-sample-parts-for-your-company-how-to-optimize-your-product-development.en";
import { theImportanceOfSpringLengthForOptimumPerformanceEN } from "./article/the-importance-of-spring-length-for-optimum-performance.en";
import { theImportanceOfSpringLoadingInTheIndustryEverythingYouNeedToKnowEN } from "./article/the-importance-of-spring-loading-in-the-industry-everything-you-need-to-know.en";
import { theImportanceOfSpringPreloadForOptimumPerformanceEN } from "./article/the-importance-of-spring-preload-for-optimum-performance.en";
import { theImportanceOfSpringStiffnessForOptimumPerformanceAndEfficiencyEN } from "./article/the-importance-of-spring-stiffness-for-optimum-performance-and-efficiency.en";
import { theImportanceOfSpringStrengthForHighQualityProductsEN } from "./article/the-importance-of-spring-strength-for-high-quality-products.en";
import { theImportanceOfTheSpringConstantInTheIndustryEN } from "./article/the-importance-of-the-spring-constant-in-the-industry.en";
import { theImportanceOfTheSpringLoadLimitForOptimumPerformanceEN } from "./article/the-importance-of-the-spring-load-limit-for-optimum-performance.en";
import { theInvisibleForceEverythingYouNeedToKnowAboutTensionSpringsEN } from "./article/the-invisible-force-everything-you-need-to-know-about-tension-springs.en";
import { theInvisibleHeroesEverythingYouNeedToKnowAboutSpringMechanismsEN } from "./article/the-invisible-heroes-everything-you-need-to-know-about-spring-mechanisms.en";
import { theMagicOfSpringSoundHowItCanBoostYourProductivityEN } from "./article/the-magic-of-spring-sound-how-it-can-boost-your-productivity.en";
import { thePerfectBalanceEverythingYouNeedToKnowAboutSuspensionSystemsEN } from "./article/the-perfect-balance-everything-you-need-to-know-about-suspension-systems.en";
import { thePerfectCoilSpringForTheHighestDemandsInIndustryEN } from "./article/the-perfect-coil-spring-for-the-highest-demands-in-industry.en";
import { thePerfectSampleConstructionForYourSuccessEN } from "./article/the-perfect-sample-construction-for-your-success.en";
import { thePerfectSolutionForEfficientSpringAssemblyInIndustryEN } from "./article/the-perfect-solution-for-efficient-spring-assembly-in-industry.en";
import { thePerfectSolutionForPreciseAndReliablePowerTransmissionPlungerWithSpringEN } from "./article/the-perfect-solution-for-precise-and-reliable-power-transmission-plunger-with-spring.en";
import { thePerfectSolutionForSmoothInstallationEverythingYouNeedToKnowAboutDetentSpringsEN } from "./article/the-perfect-solution-for-smooth-installation-everything-you-need-to-know-about-detent-springs.en";
import { thePerfectSolutionForSmoothInstallationTheSleeveSpringEN } from "./article/the-perfect-solution-for-smooth-installation-the-sleeve-spring.en";
import { thePowerOfSpringsEverythingYouNeedToKnowAboutSpringForceEN } from "./article/the-power-of-springs-everything-you-need-to-know-about-spring-force.en";
import { theRightTorsionSpringManufacturerEN } from "./article/the-right-torsion-spring-manufacturer.en";
import { theSecretsOfSpringCharacteristicsHowToFindThePerfectSpringForYourCompanyEN } from "./article/the-secrets-of-spring-characteristics-how-to-find-the-perfect-spring-for-your-company.en";
import { theUltimateGuideToUsingSpringSteelWireInTheIndustryEN } from "./article/the-ultimate-guide-to-using-spring-steel-wire-in-the-industry.en";
import { theVersatilityOfSpringMaterialsASolutionForDemandingApplicationsEN } from "./article/the-versatility-of-spring-materials-a-solution-for-demanding-applications.en";
import { torsionSpringManufacturerEN } from "./article/torsion-spring-manufacturer.en";
import { torsionSpringsForcesEN } from "./article/torsion-springs-forces.en";
import { torsionsfedernKraftDE } from "./article/torsionsfedern-kraft.de";
import { umweltmanagementPreis2023FuerDietzGmbh2DE } from "./article/umweltmanagement-preis-2023-fuer-dietz-gmbh-2.de";
import { umweltmanagementpreis2024DE } from "./article/umweltmanagementpreis-2024.de";
import { umweltpaktBayern22222DE } from "./article/umweltpakt-bayern-2-2-2-2-2.de";
import { umweltpaktBayern22223DE } from "./article/umweltpakt-bayern-2-2-2-2-3.de";
import { umweltpaktBayern22224DE } from "./article/umweltpakt-bayern-2-2-2-2-4.de";
import { umweltpaktBayern2222DE } from "./article/umweltpakt-bayern-2-2-2-2.de";
import { umweltpaktBayern222DE } from "./article/umweltpakt-bayern-2-2-2.de";
import { umweltpaktBayern22DE } from "./article/umweltpakt-bayern-2-2.de";
import { umweltpaktBayern2DE } from "./article/umweltpakt-bayern-2.de";
import { umweltpaktBayernDE } from "./article/umweltpakt-bayern.de";
import { umweltpolitikInDerPraxisLebenUndMitIdeenGemeinsamVorankommenDE } from "./article/umweltpolitik-in-der-praxis-leben-und-mit-ideen-gemeinsam-vorankommen.de";
import { umzugZumJahresendeDE } from "./article/umzug-zum-jahresende.de";
import { unserneuereTransporteristda222DE } from "./article/unserneuere-transporteristda-2-2-2.de";
import { unserneuereTransporteristda22DE } from "./article/unserneuere-transporteristda-2-2.de";
import { unserneuereTransporteristda2DE } from "./article/unserneuere-transporteristda-2.de";
import { unserneuereTransporteristdaDE } from "./article/unserneuere-transporteristda.de";
import { unsichtbareKraftSpannfedernDE } from "./article/unsichtbare-kraft-spannfedern.de";
import { unternehmenLeistungenLogistikDE } from "./article/unternehmen--leistungen--logistik.de";
import { unternehmenLeistungenMaterialauswahlDE } from "./article/unternehmen--leistungen--materialauswahl.de";
import { unternehmenLeistungenProduktionDE } from "./article/unternehmen--leistungen--produktion.de";
import { unternehmenLeistungenQualitaetDE } from "./article/unternehmen--leistungen--qualitaet.de";
import { unternehmenLeistungenDE } from "./article/unternehmen--leistungen.de";
import { unternehmenQualitaetUmweltDE } from "./article/unternehmen--qualitaet-umwelt.de";
import { unternehmenUnserePartnerUndMitgliedschaftenDE } from "./article/unternehmen--unsere-partner-und-mitgliedschaften.de";
import { unternehmenUnsereUnternehmenspolitikDE } from "./article/unternehmen--unsere-unternehmenspolitik.de";
import { unternehmenDE } from "./article/unternehmen.de";
import { updateNeuesVerwaltungsgebaeudeDE } from "./article/update-neues-verwaltungsgebaeude.de";
import { urkundenuebergabeUmweltpaktBayernDE } from "./article/urkundenuebergabe-umweltpakt-bayern.de";
import { valveSpringWireEN } from "./article/valve-spring-wire.en";
import { ventilfederdrahtDE } from "./article/ventilfederdraht.de";
import { wasIstEineFederwindemaschineDE } from "./article/was-ist-eine-federwindemaschine.de";
import { wasIstVentilfederdrahtDE } from "./article/was-ist-ventilfederdraht.de";
import { waveSpringManufacturerEN } from "./article/wave-spring-manufacturer.en";
import { waveSpringsForUpholsteredFurnitureEN } from "./article/wave-springs-for-upholstered-furniture.en";
import { waveSpringsInSofasEN } from "./article/wave-springs-in-sofas.en";
import { wellenfederherstellerDE } from "./article/wellenfederhersteller.de";
import { wellenfedernFuerPolstermoebelDE } from "./article/wellenfedern-fuer-polstermoebel.de";
import { wellenfedernInSofasDE } from "./article/wellenfedern-in-sofas.de";
import { whatExactlyAreConstantForceSpringsEN } from "./article/what-exactly-are-constant-force-springs.en";
import { whatIsASpringCoilingMachineEN } from "./article/what-is-a-spring-coiling-machine.en";
import { whatIsValveSpringWireEN } from "./article/what-is-valve-spring-wire.en";
import { whistleblowerSystemEN } from "./article/whistleblower-system.en";
import { wieFunktioniertEineSpiralfedermaschineDE } from "./article/wie-funktioniert-eine-spiralfedermaschine.de";
import { wieGaragentorfedernFunktionierenDE } from "./article/wie-garagentorfedern-funktionieren.de";
import { wirHabenUnserNetzwerkErweitertDE } from "./article/wir-haben-unser-netzwerk-erweitert.de";
import { wirHandelnFuerEinKlimaneutralesBayern2040DE } from "./article/wir-handeln-fuer-ein-klimaneutrales-bayern-2040.de";
import { wirOeffnenDieTuerenZuUnsererProduktionDE } from "./article/wir-oeffnen-die-tueren-zu-unserer-produktion.de";
import { wirSindGruendungsmitgliedImUnternehmensnetzwerkKlimaschutzDE } from "./article/wir-sind-gruendungsmitglied-im-unternehmensnetzwerk-klimaschutz.de";
import { wireBendingPartsManufacturerEN } from "./article/wire-bending-parts-manufacturer.en";
import { wissenDE } from "./article/wissen.de";
import { zugfederherstellerDE } from "./article/zugfederhersteller.de";
import { zugfedernFuerGaragentoreDE } from "./article/zugfedern-fuer-garagentore.de";
import { zugfedernMitEingerolltemHakenDE } from "./article/zugfedern-mit-eingerolltem-haken.de";
import { zugfedernMitGewindebolzenDE } from "./article/zugfedern-mit-gewindebolzen.de";
import { zugfedernMitGewindestopfenDE } from "./article/zugfedern-mit-gewindestopfen.de";
import { zugfedernMitHakenDE } from "./article/zugfedern-mit-haken.de";
import { zugfedernMitOeseDE } from "./article/zugfedern-mit-oese.de";
import { zugfedernMitOesenDE } from "./article/zugfedern-mit-oesen.de";
import { zugfedernNachDin2098DE } from "./article/zugfedern-nach-din-2098.de";
import { zugfedernNachMass2DE } from "./article/zugfedern-nach-mass-2.de";
import { zugfedernNachMassDE } from "./article/zugfedern-nach-mass.de";
import { zugfedernRostfreiDE } from "./article/zugfedern-rostfrei.de";
import { zylindrischeSchraubendruckfedernDE } from "./article/zylindrische-schraubendruckfedern.de";
import { contactDe } from "./contact/de";
import { contactEn } from "./contact/en";
import { produkteAnpressfederDE } from "./example/produkte--anpressfeder.de";
import { produkteContactBarEN } from "./example/produkte--contact-bar.en";
import { produkteFuseHolderEN } from "./example/produkte--fuse-holder.en";
import { produkteGearMadeOfPolyoxymethyleneEN } from "./example/produkte--gear-made-of-polyoxymethylene.en";
import { produkteHalteklammerDE } from "./example/produkte--halteklammer.de";
import { produkteHebelAusPolyamidPaDE } from "./example/produkte--hebel-aus-polyamid-pa.de";
import { produkteKontaktschieneDE } from "./example/produkte--kontaktschiene.de";
import { produkteLeverMadeOfPolyamidePaEN } from "./example/produkte--lever-made-of-polyamide-pa.en";
import { produkteMechanicalEngineeringAssemblyPartEN } from "./example/produkte--mechanical-engineering-assembly-part.en";
import { produkteMontagesetFuerDialysegeraeteDE } from "./example/produkte--montageset-fuer-dialysegeraete.de";
import { produkteMontageteilMaschinenbauDE } from "./example/produkte--montageteil-maschinenbau.de";
import { produkteMountingKitForDialysisMachinesEN } from "./example/produkte--mounting-kit-for-dialysis-machines.en";
import { produktePackaging1EN } from "./example/produkte--packaging-1.en";
import { produktePackaging2EN } from "./example/produkte--packaging-2.en";
import { produktePackaging3EN } from "./example/produkte--packaging-3.en";
import { produktePressureSpringEN } from "./example/produkte--pressure-spring.en";
import { produkteRasthuelsenbaugruppeDE } from "./example/produkte--rasthuelsenbaugruppe.de";
import { produkteRetainingClipInAutomotiveTechnologyEN } from "./example/produkte--retaining-clip-in-automotive-technology.en";
import { produkteRollerShutterLeatherEN } from "./example/produkte--roller-shutter-leather.en";
import { produkteRollofederDE } from "./example/produkte--rollofeder.de";
import { produkteSchenkelfederFuerBremselementImPkwFensterheberDE } from "./example/produkte--schenkelfeder-fuer-bremselement-im-pkw-fensterheber.de";
import { produkteSchenkelfederInDerBeleuchtungstechnikDE } from "./example/produkte--schenkelfeder-in-der-beleuchtungstechnik.de";
import { produkteSchenkelfedernZumOeffnenEinerKlappeBeiGeschirrspuelmaschinenDE } from "./example/produkte--schenkelfedern-zum-oeffnen-einer-klappe-bei-geschirrspuelmaschinen.de";
import { produkteSchukoClampEN } from "./example/produkte--schuko-clamp.en";
import { produkteSchukoKlammerDE } from "./example/produkte--schuko-klammer.de";
import { produkteSchweissringeDE } from "./example/produkte--schweissringe.de";
import { produkteSicherungshalterDE } from "./example/produkte--sicherungshalter.de";
import { produkteSiliconeSpringAsBrakeElementEN } from "./example/produkte--silicone-spring-as-brake-element.en";
import { produkteSilikonfederAlsBremselementDE } from "./example/produkte--silikonfeder-als-bremselement.de";
import { produkteSitzwannenverstaerkungLordosenstuetzeDE } from "./example/produkte--sitzwannenverstaerkung-lordosenstuetze.de";
import { produkteSonderdruckfederMitLoetbarerOberflaecheDE } from "./example/produkte--sonderdruckfeder-mit-loetbarer-oberflaeche.de";
import { produkteSpecialCompressionSpringWithSolderableSurfaceEN } from "./example/produkte--special-compression-spring-with-solderable-surface.en";
import { produkteSpulenkoerperDE } from "./example/produkte--spulenkoerper.de";
import { produkteTensionSpringWithExtraLongEyeletEN } from "./example/produkte--tension-spring-with-extra-long-eyelet.en";
import { produkteThighSpringsForOpeningAFlapInDishwashersEN } from "./example/produkte--thigh-springs-for-opening-a-flap-in-dishwashers.en";
import { produkteThighSpringsInLightingTechnologyEN } from "./example/produkte--thigh-springs-in-lighting-technology.en";
import { produkteWaveRingEN } from "./example/produkte--wave-ring.en";
import { produkteWeldingRingsEN } from "./example/produkte--welding-rings.en";
import { produkteWellenfederturmFuerThermomanagementsystemDE } from "./example/produkte--wellenfederturm-fuer-thermomanagementsystem.de";
import { produkteWellenringDE } from "./example/produkte--wellenring.de";
import { produkteZahnradAusPolyoxymethylenDE } from "./example/produkte--zahnrad-aus-polyoxymethylen.de";
import { produkteZahnradachseDE } from "./example/produkte--zahnradachse.de";
import { produkteZugfederImBereichDerSitzeImPkwDE } from "./example/produkte--zugfeder-im-bereich-der-sitze-im-pkw.de";
import { produkteZugfederMitUeberlagerterOeseDE } from "./example/produkte--zugfeder-mit-ueberlagerter-oese.de";
import { homepageDe } from "./homepage/de";
import { homepageEn } from "./homepage/en";
import { kunststofftechnikDE } from "./product/kunststofftechnik.de";
import { praezisionsfedernDE } from "./product/praezisionsfedern.de";
import { precisionSpringsEN } from "./product/precision-springs.en";
import { productsBentWirePartsEN } from "./product/products--bent-wire-parts.en";
import { productsCompressionSpringsEN } from "./product/products--compression-springs.en";
import { productsExtensionSpringsEN } from "./product/products--extension-springs.en";
import { productsHybridAssembliesEN } from "./product/products--hybrid-assemblies.en";
import { productsPlasticsTechnologyEN } from "./product/products--plastics-technology.en";
import { productsPrecisionSpringsEN } from "./product/products--precision-springs.en";
import { productsPrototypeAndSampleConstructionEN } from "./product/products--prototype-and-sample-construction.en";
import { productsPrototypeAndSampleDevelopmentEN } from "./product/products--prototype-and-sample-development.en";
import { productsSpecialPackagingEN } from "./product/products--special-packaging.en";
import { productsStampedAndFormedPartsEN } from "./product/products--stamped-and-formed-parts.en";
import { productsStripBendingPartsEN } from "./product/products--strip-bending-parts.en";
import { productsTorsionSpringsEN } from "./product/products--torsion-springs.en";
import { productsWaveSpringsEN } from "./product/products--wave-springs.en";
import { produkteBandbiegeteileDE } from "./product/produkte--bandbiegeteile.de";
import { produkteDrahtbiegeteileDE } from "./product/produkte--drahtbiegeteile.de";
import { produkteDruckfedernDE } from "./product/produkte--druckfedern.de";
import { produkteHybrideBaugruppenDE } from "./product/produkte--hybride-baugruppen.de";
import { produktePrototypenUndMusterbauDE } from "./product/produkte--prototypen-und-musterbau.de";
import { produkteSchenkelfedernDE } from "./product/produkte--schenkelfedern.de";
import { produkteSonderverpackungenDE } from "./product/produkte--sonderverpackungen.de";
import { produkteWellenfedernDE } from "./product/produkte--wellenfedern.de";
import { produkteZugfedernDE } from "./product/produkte--zugfedern.de";
import { sonderverpackungenDE } from "./product/sonderverpackungen.de";
import { stanzUmformteileDE } from "./product/stanz-umformteile.de";

const ALL: PageEntry[] = [
  p17DeutscheNachhaltigkeitspreisDE,
  p3dDruckDE,
  p3dPrintingEN,
  p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg222DE,
  p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg22DE,
  p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg2DE,
  p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburgDE,
  aktionHerzensretterDE,
  allesWasSieUeberDieBerechnungVonFedernWissenMuessenDE,
  allesWasSieUeberDieFederpruefungWissenMuessenDE,
  allesWasSieUeberFederabmessungenWissenMuessenDE,
  allesWasSieUeberFedernormenWissenMuessenDE,
  allesWasSieUeberFederratenWissenMuessenDE,
  allesWasSieUeberFedertypenWissenMuessenDE,
  ausbildungUndNachwuchsleistungssportJuliusSieglerImPortraetDE,
  ausbildungZumElektronikerMWDDE,
  ausbildungZumFachlageristMWDDE,
  ausbildungZumIndustriekaufmannFrauMWDDE,
  ausbildungZumIndustriemechanikerWerkzeugmechanikerMWDDE,
  ausbildungZumTechnischenProduktdesignerDE,
  ausbildungZumZurMaschinenAnlagenfuehrerInDE,
  ausbildungZurFachkraftFuerLagerlogistikMWDDE,
  ausbildung2023DE,
  ausbildungsstart2021DE,
  ausbildungsstart20222DE,
  automobilfedernherstellerDE,
  automotiveSpringManufacturerEN,
  azubiEventOktober20222DE,
  azubiEventOktober2022DE,
  azubiSeminarInFuersteneckDE,
  baufortschrittInSonnebergDE,
  bedeutungFedervorspannungOptimaleLeistungDE,
  beispielEinbauSchenkelfederDE,
  blogDE,
  blogEN,
  branchenAutomotiveDE,
  branchenElektrotechnikDE,
  branchenMedizintechnikDE,
  branchenWeisseWareDE,
  branchenWeitereBranchenDE,
  branchenDE,
  careersEN,
  cncDrahtbiegeteileDE,
  cncFraesenPrototypenbauDE,
  cncMillingPrototypeConstructionEN,
  cncPrototypenbauDE,
  cncPrototypingEN,
  cncWireBendingPartsEN,
  coilSpringEN,
  coilSpringsForVehiclesEN,
  compressionCoilSpringsEN,
  compressionSpringManufacturerEN,
  compressionSpringsDin2095EN,
  compressionSpringsDinIso10243EN,
  compressionSpringsWithScrewThreadEN,
  conicalCompressionSpringsEN,
  cookieRichtlinieEuDE,
  coolBleibenBeiHeissenTemperaturenDE,
  costOfPrototypeSuspensionEN,
  customMadeSpringsOfTheHighestQualityEN,
  customTensionSpringsEN,
  customisedCompressionSpringsEN,
  customisedTensionSpringsMadeToMeasureEN,
  customizedDiscSpringsTheKeyToEfficientSpringSolutionsEN,
  customizedLeafSpringsForTheHighestDemandsInTheIndustryEN,
  cylindricalHelicalCompressionEN,
  datenschutzerklaerungDE,
  derBackCheckMitDerAokBayernDE,
  derRichtigeSchenkelfederherstellerDE,
  derUltimativeLeitfadenEinsatzFederstahldrahtIndustrieDE,
  detentSpringEN,
  developStampedBentPartsPrototypesEN,
  dieBedeutungDerFederbelastungsgrenzeDE,
  dieBedeutungDerFederfestigkeitDE,
  dieBedeutungDerFederkonstanteInDerIndustrieDE,
  dieBedeutungDerFederlaengeFuerEineOptimaleLeistungDE,
  dieBedeutungDerFedersteifigkeitFuerOptimaleLeistungUndEffizienzDE,
  dieBedeutungDerMusterentwicklungFuerIhrUnternehmenDE,
  dieBedeutungVonFederbelastungInDerIndustrieAllesWasSieWissenMuessenDE,
  dieBedeutungVonHandmusternInDerB2bBrancheDE,
  dieBedeutungVonMusterteilenFuerIhrUnternehmenSoOptimierenSieIhreProduktentwicklungDE,
  dieBedeutungVonPraezisionsfedernInDerIndustrieDE,
  dieGeheimnisseDerFedercharakteristikSoFindenSieDiePerfekteFederFuerIhrUnternehmenDE,
  dieKraftDerFedernAllesWasSieUeberFederkraftWissenMuessenDE,
  dieKunstDerFederherstellungDE,
  dieKunstDerMustererstellungSoOptimierenSieIhreProduktentwicklungDE,
  dieKunstDesFederdesignsPerfekteLoesungenFuerIhreAnforderungenDE,
  dieMagieDesFedergeraeuschsWieEsIhreProduktivitaetSteigernKannDE,
  diePerfekteBalanceAllesWasSieUeberFederungssystemeWissenMuessenDE,
  diePerfekteLoesungFuerEineEffizienteFedermontageDE,
  diePerfekteLoesungFuerEineReibungsloseMontageAllesWasSieUeberRastfedernWissenMuessenDE,
  diePerfekteLoesungFuerEineReibungsloseMontageDieHuelsenfederDE,
  diePerfekteLoesungFuerPraeziseUndZuverlaessigeKraftuebertragungStoeselMitFederDE,
  diePerfekteMusterkonstruktionFuerIhrenErfolgDE,
  diePerfekteSchraubenfederFuerHoechsteAnspruecheInDerIndustrieDE,
  dieUnsichtbarenHeldenAllesWasSieUeberFedermechanismenWissenMuessenDE,
  dieVielseitigkeitVonFederwerkstoffenDE,
  dieVorteileEinerHochwertigenFederbeschichtungDE,
  dieZukunftDerFertigungAllesWasSieUeberDen3dDruckWissenMuessenDE,
  dietzErweitertSeineProduktionNasenbuegelFuerSchutzmasken2DE,
  dietzErweitertSeineProduktionNasenbuegelFuerSchutzmaskenDE,
  dietzGmbhErneutFuerDeutschenNachhaltigkeitspreisNominiertDE,
  dietzGmbhImSpotlightUnserEngagementFuerDenKlimaschutzDE,
  dietzGmbhUnterDerRubrikCoburgsBesteNeuImCoburgerMagazinDE,
  dietzJubilarfeier22DE,
  dietzJubilarfeier2DE,
  dietzJubilarfeierDE,
  dietzMitarbeiterGewinnenHsc2000CoburgTicketsDE,
  dietzSagtHalloBeiLinkedinUndXing2DE,
  dietzSagtHalloBeiLinkedinUndXingDE,
  discSpringManufacturersEN,
  doppelschenkelfedernMechanischeSystemeDE,
  doubleLegSpringsEN,
  downloadsDE,
  downloadsEN,
  drahtbiegeteileAusEdelstahlDE,
  drahtbiegeteileHerstellerDE,
  drahtbiegeteileInKleinserieDE,
  dreifachNominiertUndJetztFinalistDE,
  druckfederherstellerDE,
  druckfedernMitSchraubgewindeDE,
  druckfedernNachDin2095DE,
  druckfedernNachDinIso10243DE,
  ecovadisBronzeMedailleDE,
  edelstahlDruckfedernDE,
  edelstahlKompressionsfedernDE,
  edelstahlZugfedernDE,
  effectiveSolutionsForReducingSpringFrictionInTheIndustryEN,
  effektiveLoesungenReduzierungFederreibungIndustrieDE,
  efficientSpringInstallationHowToOptimizeYourProductionProcessesEN,
  effizienteFederinstallationOptimierenProduktionsprozesseDE,
  einmalZumNordkapUndZurueckDE,
  electronica2018DE,
  elektronikerMWDDE,
  enterpriseBusinessPolicyEN,
  enterprisePartnerEN,
  enterprisePerformancesLogisticsEN,
  enterprisePerformancesMaterialEN,
  enterprisePerformancesProductionEN,
  enterprisePerformancesQualityEN,
  enterprisePerformancesEN,
  enterpriseSustainabilityEN,
  enterpriseEN,
  ersteDietzUmweltwocheDE,
  europassVerleihungDietzAzubisAlsAusbildungsbotschafterDE,
  everythingYouNeedToKnowAboutCalculatingSpringsEN,
  everythingYouNeedToKnowAboutSpringDimensionsEN,
  everythingYouNeedToKnowAboutSpringRatesEN,
  everythingYouNeedToKnowAboutSpringStandardsEN,
  everythingYouNeedToKnowAboutSpringTypesEN,
  everythingYouNeedToKnowAboutTheSpringTestEN,
  extensionSpringsWithCoiledHookEN,
  extensionSpringsWithEyeletEN,
  fabrikImSeminarraum2DE,
  fabrikImSeminarraumDE,
  federabmessungenDE,
  federbeanspruchungDE,
  federbelastungDE,
  federbelastungsgrenzeDE,
  federberechnungDE,
  federbeschichtungDE,
  federcharakteristikDE,
  federdesignDE,
  federfestigkeitDE,
  federgeraeuschDE,
  federherstellungDE,
  federherstellungstechnikenDE,
  federinstallationDE,
  federkennzeichnungDE,
  federkennzeichnungenDE,
  federkonstanteDE,
  federkraftDE,
  federlaengeDE,
  federmaterialDE,
  federmechanismenDE,
  federmontageDE,
  federnFuerTechnikDieOptimaleLoesungFuerTechnischeAnwendungenDE,
  federnHerstellerDE,
  federnInDerMedizintechnikDE,
  federnfabrikDietzGmbhUnterDenNominiertenDE,
  federnormenDE,
  federntechnikDE,
  federpruefungDE,
  federrateDE,
  federreibungDE,
  federstahldrahtDE,
  federsteifigkeitDE,
  federtypenDE,
  federungssystemeDE,
  federvorspannungDE,
  federwerkstoffDE,
  federwerkstoffeDE,
  federwindeautomatenDE,
  findLeafSpringsManufacturersEN,
  findTheRightCompressionSpringManufacturerEN,
  findenSieHerstellerVonBlattfedernDE,
  firmenstandortSonnebergStartschussFaelltMitKundenfreigabe2DE,
  firmenstandortSonnebergStartschussFaelltMitKundenfreigabeDE,
  flachdrahtDruckfedernDE,
  flachdrahtWellenfedernDE,
  flacheDruckfedernDE,
  flatCompressionSpringsEN,
  flatWireCompressionSpringsEN,
  flatWireWaveSpringsEN,
  flexibilitaetUndQualitaetFedernNachMassIndividuellAngefertigtFuerIhrUnternehmenDE,
  followUsOnInstagram222DE,
  followUsOnInstagram22DE,
  followUsOnInstagram2DE,
  followUsOnInstagramDE,
  garageDoorSpringsEN,
  glossarDE,
  glossaryEN,
  halterungenFuerWellenfedernDE,
  handPatternsEN,
  handmusterDE,
  herstellerFuerDruckfedernDE,
  herzlichenGlueckwunschZurBerufsausbildungDE,
  hightechlive2DE,
  hightechliveDE,
  hinweisgebersystemDE,
  howDoesACoilSpringMachineWorkEN,
  huelsenfederDE,
  impressumDE,
  imprintEN,
  industrie40DE,
  industriesAutomotiveEN,
  industriesElectricalEngineeringEN,
  industriesMedicalEN,
  industriesOtherIndustriesEN,
  industriesWhiteGoodsEN,
  industriesEN,
  infosZurAktuellenLageDE,
  installationOfATorsionSpringEN,
  integrationDurchArbeitWirtschaftsministerinAignerZeichnetFirmenAusDE,
  karriereAusbildungDE,
  karriereDualesStudiumDE,
  karriereFachkraefteDE,
  karriereInitativbewerbungDE,
  karrierePraktikumDE,
  karriereDE,
  kleineDruckfedernDE,
  kleineTorsionsfedernDE,
  kleineZugfedernDE,
  konischeDruckfedernDE,
  konstantkraftfedernDE,
  kostenPrototypenfederungenDE,
  kunststoffteileMaschinenbauDE,
  leitfadenSchraubendruckfedernDE,
  maschineneinrichterStanzUmformtechnikMWDDE,
  massgefertigteBlattfedernHoechsteAnspruecheIndustrieDE,
  massgefertigteDruckfedernDE,
  massgefertigteFedernDE,
  massgeschneiderteTellerfedernEffizienteZuverlaessigeFederloesungenDE,
  meaningOfSpringMarkingsEN,
  mehrAlsNurFedernDE,
  metalPrintingEN,
  metalPrototypingEN,
  metalldruckDE,
  mitarbeiterfestDerDietzGmbhDE,
  mountsForWaveSpringsEN,
  musterbauProduktentwicklungDE,
  musterdesignDE,
  musterentwicklungDE,
  mustererstellungDE,
  musterkonstruktionDE,
  musterteileDE,
  necazubi2025AusbildungsmesseDE,
  necazubi2026DeineChanceAufDenTraumAusbildungsplatzDE,
  neueAuszubildendeInFuersteneckDE,
  neueHalleInSonnebergUmzugUnsererMontagetechnikDE,
  neustadtHilftDE,
  newsDE,
  optimalSpringLoadingHowToMaximizeThePerformanceOfYourMachinesEN,
  optimaleFederbeanspruchungWieSieDieLeistungIhrerMaschinenMaximierenDE,
  performanceCoilSpringsEN,
  plasticPartsInMechanicalEngineeringEN,
  plasticPrototypingEN,
  plasticSpringManufacturersAComprehensiveOverviewEN,
  plastikfedernHerstellerDE,
  plungerWithSpringEN,
  praktikumBeiDerDietzGmbhDE,
  privacyPolicyEN,
  produceStampedBentPartsInSmallSeriesEN,
  productionOfBentWirePartsInSmallSeriesEN,
  productsEN,
  produkteDE,
  produktionTechnischeKunststoffteileDE,
  prototypeConstructionSupplierEN,
  prototypeConstructionEN,
  prototypeHousingEN,
  prototypenbauAusKunststoffDE,
  prototypenbauAusMetallDE,
  prototypenbauInDerMedizintechnikDE,
  prototypenbauLieferantenDE,
  prototypenbauMit3dDruckDE,
  prototypgehaeuseDE,
  prototypingExplainedEN,
  prototypingInMedicalTechnologyEN,
  prototypingProductDevelopmentEN,
  prototypingWith3dPrintingEN,
  rastfederDE,
  reinigungskraftMwdMitLeidenschaftFuerOrdnungDE,
  resourcesEN,
  sampleDesignEN,
  sampleDevelopmentEN,
  samplePartsEN,
  saveTheDateNecazubiAusbildungsmesseDE,
  schenkelfederherstellerDE,
  schenkelfedermaschineFmu08DE,
  schoolMeetsWorkDE,
  schraubenfederDE,
  sleeveSpringEN,
  smallCompressionSpringsEN,
  smallTensionSpringsEN,
  smallTorsionSpringsEN,
  spannfederDE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg22DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg2DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg32DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg332DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg33DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburg3DE,
  spendeFuerDieStiftungFuerKrebskrankeKinderCoburgDE,
  spendenStattGeschenkeDE,
  spiralAndCompressionSpringsEN,
  spiralSpringManufacturerEN,
  spiralfederherstellerDE,
  spiralfedernAnwendungenDE,
  spiralfedernDruckfedernDE,
  spiralfedernFuerFahrzeugeDE,
  springAssemblyEN,
  springCalculationEN,
  springCharacteristicsEN,
  springCoatingEN,
  springCoilingMachinesEN,
  springConstantEN,
  springDesignEN,
  springDimensionsEN,
  springForceEN,
  springFrictionEN,
  springInstallationEN,
  springLabellingEN,
  springLengthEN,
  springLoadLimitEN,
  springLoadingEN,
  springManufacturerEN,
  springManufacturingTechniquesExplainedEN,
  springManufacturingTechniquesEN,
  springMaterial2EN,
  springMaterialEN,
  springMaterialsTheBigGuideEN,
  springMechanismsEN,
  springNoiseEN,
  springPreloadEN,
  springProductionEN,
  springRateEN,
  springStandardsEN,
  springSteelWireEN,
  springStiffnessEN,
  springStrengthEN,
  springStressEN,
  springTechnologyAnInnovativeSolutionEN,
  springTestingEN,
  springTypesEN,
  springsForTechnologyTheOptimalSolutionForTechnicalApplicationsEN,
  springsInMedicalTechnologyEN,
  stahlfederherstellerDE,
  stainlessSteelBentWirePartsEN,
  stainlessSteelCompressionSprings2EN,
  stainlessSteelCompressionSpringsEN,
  stainlessSteelTensionSprings2EN,
  stainlessSteelTensionSpringsEN,
  stampedAndBentPartsMadeFromSpringSteelEN,
  stampedAndBentPartsPerfectlyShapedAndPreciselyManufacturedEN,
  stampedAndFormedPartsSuppliersEN,
  stampedBentPartsManufacturerEN,
  stanzUndBiegeteileAusFederstahlDE,
  stanzbiegeteileHerstellerDE,
  stanzbiegeteileKleinserieDE,
  stanzbiegeteileLieferantenDE,
  stanzbiegeteilePrototypenDE,
  stanzbiegeteileDE,
  starkeDruckfedernDE,
  starkeZugfedernDE,
  steelSpringManufacturerEN,
  stoesselMitFederDE,
  strongCompressionSpringsEN,
  strongTensionSpringsEN,
  suspensionSystemsEN,
  tailorMadeSpringsCustomizedForYourCompanyEN,
  technicalPlasticPartsEN,
  technicalSpringManufacturerEN,
  technicalSpringsProductionEN,
  technikenFederherstellungDE,
  technischeFedernHerstellerDE,
  technischeFedernDE,
  technischeKunststoffteileUndMetallkomponentenVereint2DE,
  tellerfedernHerstellerDE,
  tensionSpringManufacturerEN,
  tensionSpringEN,
  tensionSpringsAccordingToDin2098EN,
  tensionSpringsForGarageDoorsEN,
  tensionSpringsWithEyeletsEN,
  tensionSpringsWithHooksEN,
  tensionSpringsWithThreadedBoltsEN,
  tensionSpringsWithThreadedPlugsEN,
  theAdvantagesOfAHighQualitySpringCoatingForYourProductsEN,
  theArtOfSampleCreationHowToOptimizeYourProductDevelopmentEN,
  theArtOfSpringDesignPerfectSolutionsForYourRequirementsEN,
  theArtOfSpringProductionQualityAndPrecisionForYourSuccessEN,
  theFutureOfManufacturingEverythingYouNeedToKnowAbout3dPrintingEN,
  theImportanceOfHandSamplesInTheB2bSectorWhyTheyAreIndispensableEN,
  theImportanceOfPatternDevelopmentForYourCompanyEN,
  theImportanceOfPrecisionSpringsInTheIndustryEN,
  theImportanceOfSamplePartsForYourCompanyHowToOptimizeYourProductDevelopmentEN,
  theImportanceOfSpringLengthForOptimumPerformanceEN,
  theImportanceOfSpringLoadingInTheIndustryEverythingYouNeedToKnowEN,
  theImportanceOfSpringPreloadForOptimumPerformanceEN,
  theImportanceOfSpringStiffnessForOptimumPerformanceAndEfficiencyEN,
  theImportanceOfSpringStrengthForHighQualityProductsEN,
  theImportanceOfTheSpringConstantInTheIndustryEN,
  theImportanceOfTheSpringLoadLimitForOptimumPerformanceEN,
  theInvisibleForceEverythingYouNeedToKnowAboutTensionSpringsEN,
  theInvisibleHeroesEverythingYouNeedToKnowAboutSpringMechanismsEN,
  theMagicOfSpringSoundHowItCanBoostYourProductivityEN,
  thePerfectBalanceEverythingYouNeedToKnowAboutSuspensionSystemsEN,
  thePerfectCoilSpringForTheHighestDemandsInIndustryEN,
  thePerfectSampleConstructionForYourSuccessEN,
  thePerfectSolutionForEfficientSpringAssemblyInIndustryEN,
  thePerfectSolutionForPreciseAndReliablePowerTransmissionPlungerWithSpringEN,
  thePerfectSolutionForSmoothInstallationEverythingYouNeedToKnowAboutDetentSpringsEN,
  thePerfectSolutionForSmoothInstallationTheSleeveSpringEN,
  thePowerOfSpringsEverythingYouNeedToKnowAboutSpringForceEN,
  theRightTorsionSpringManufacturerEN,
  theSecretsOfSpringCharacteristicsHowToFindThePerfectSpringForYourCompanyEN,
  theUltimateGuideToUsingSpringSteelWireInTheIndustryEN,
  theVersatilityOfSpringMaterialsASolutionForDemandingApplicationsEN,
  torsionSpringManufacturerEN,
  torsionSpringsForcesEN,
  torsionsfedernKraftDE,
  umweltmanagementPreis2023FuerDietzGmbh2DE,
  umweltmanagementpreis2024DE,
  umweltpaktBayern22222DE,
  umweltpaktBayern22223DE,
  umweltpaktBayern22224DE,
  umweltpaktBayern2222DE,
  umweltpaktBayern222DE,
  umweltpaktBayern22DE,
  umweltpaktBayern2DE,
  umweltpaktBayernDE,
  umweltpolitikInDerPraxisLebenUndMitIdeenGemeinsamVorankommenDE,
  umzugZumJahresendeDE,
  unserneuereTransporteristda222DE,
  unserneuereTransporteristda22DE,
  unserneuereTransporteristda2DE,
  unserneuereTransporteristdaDE,
  unsichtbareKraftSpannfedernDE,
  unternehmenLeistungenLogistikDE,
  unternehmenLeistungenMaterialauswahlDE,
  unternehmenLeistungenProduktionDE,
  unternehmenLeistungenQualitaetDE,
  unternehmenLeistungenDE,
  unternehmenQualitaetUmweltDE,
  unternehmenUnserePartnerUndMitgliedschaftenDE,
  unternehmenUnsereUnternehmenspolitikDE,
  unternehmenDE,
  updateNeuesVerwaltungsgebaeudeDE,
  urkundenuebergabeUmweltpaktBayernDE,
  valveSpringWireEN,
  ventilfederdrahtDE,
  wasIstEineFederwindemaschineDE,
  wasIstVentilfederdrahtDE,
  waveSpringManufacturerEN,
  waveSpringsForUpholsteredFurnitureEN,
  waveSpringsInSofasEN,
  wellenfederherstellerDE,
  wellenfedernFuerPolstermoebelDE,
  wellenfedernInSofasDE,
  whatExactlyAreConstantForceSpringsEN,
  whatIsASpringCoilingMachineEN,
  whatIsValveSpringWireEN,
  whistleblowerSystemEN,
  wieFunktioniertEineSpiralfedermaschineDE,
  wieGaragentorfedernFunktionierenDE,
  wirHabenUnserNetzwerkErweitertDE,
  wirHandelnFuerEinKlimaneutralesBayern2040DE,
  wirOeffnenDieTuerenZuUnsererProduktionDE,
  wirSindGruendungsmitgliedImUnternehmensnetzwerkKlimaschutzDE,
  wireBendingPartsManufacturerEN,
  wissenDE,
  zugfederherstellerDE,
  zugfedernFuerGaragentoreDE,
  zugfedernMitEingerolltemHakenDE,
  zugfedernMitGewindebolzenDE,
  zugfedernMitGewindestopfenDE,
  zugfedernMitHakenDE,
  zugfedernMitOeseDE,
  zugfedernMitOesenDE,
  zugfedernNachDin2098DE,
  zugfedernNachMass2DE,
  zugfedernNachMassDE,
  zugfedernRostfreiDE,
  zylindrischeSchraubendruckfedernDE,
  contactDe,
  contactEn,
  produkteAnpressfederDE,
  produkteContactBarEN,
  produkteFuseHolderEN,
  produkteGearMadeOfPolyoxymethyleneEN,
  produkteHalteklammerDE,
  produkteHebelAusPolyamidPaDE,
  produkteKontaktschieneDE,
  produkteLeverMadeOfPolyamidePaEN,
  produkteMechanicalEngineeringAssemblyPartEN,
  produkteMontagesetFuerDialysegeraeteDE,
  produkteMontageteilMaschinenbauDE,
  produkteMountingKitForDialysisMachinesEN,
  produktePackaging1EN,
  produktePackaging2EN,
  produktePackaging3EN,
  produktePressureSpringEN,
  produkteRasthuelsenbaugruppeDE,
  produkteRetainingClipInAutomotiveTechnologyEN,
  produkteRollerShutterLeatherEN,
  produkteRollofederDE,
  produkteSchenkelfederFuerBremselementImPkwFensterheberDE,
  produkteSchenkelfederInDerBeleuchtungstechnikDE,
  produkteSchenkelfedernZumOeffnenEinerKlappeBeiGeschirrspuelmaschinenDE,
  produkteSchukoClampEN,
  produkteSchukoKlammerDE,
  produkteSchweissringeDE,
  produkteSicherungshalterDE,
  produkteSiliconeSpringAsBrakeElementEN,
  produkteSilikonfederAlsBremselementDE,
  produkteSitzwannenverstaerkungLordosenstuetzeDE,
  produkteSonderdruckfederMitLoetbarerOberflaecheDE,
  produkteSpecialCompressionSpringWithSolderableSurfaceEN,
  produkteSpulenkoerperDE,
  produkteTensionSpringWithExtraLongEyeletEN,
  produkteThighSpringsForOpeningAFlapInDishwashersEN,
  produkteThighSpringsInLightingTechnologyEN,
  produkteWaveRingEN,
  produkteWeldingRingsEN,
  produkteWellenfederturmFuerThermomanagementsystemDE,
  produkteWellenringDE,
  produkteZahnradAusPolyoxymethylenDE,
  produkteZahnradachseDE,
  produkteZugfederImBereichDerSitzeImPkwDE,
  produkteZugfederMitUeberlagerterOeseDE,
  homepageDe,
  homepageEn,
  kunststofftechnikDE,
  praezisionsfedernDE,
  precisionSpringsEN,
  productsBentWirePartsEN,
  productsCompressionSpringsEN,
  productsExtensionSpringsEN,
  productsHybridAssembliesEN,
  productsPlasticsTechnologyEN,
  productsPrecisionSpringsEN,
  productsPrototypeAndSampleConstructionEN,
  productsPrototypeAndSampleDevelopmentEN,
  productsSpecialPackagingEN,
  productsStampedAndFormedPartsEN,
  productsStripBendingPartsEN,
  productsTorsionSpringsEN,
  productsWaveSpringsEN,
  produkteBandbiegeteileDE,
  produkteDrahtbiegeteileDE,
  produkteDruckfedernDE,
  produkteHybrideBaugruppenDE,
  produktePrototypenUndMusterbauDE,
  produkteSchenkelfedernDE,
  produkteSonderverpackungenDE,
  produkteWellenfedernDE,
  produkteZugfedernDE,
  sonderverpackungenDE,
  stanzUmformteileDE,
];

const byLocaleSlug = new Map<string, PageEntry>();
const byId = new Map<string, Map<Locale, PageEntry>>();

for (const entry of ALL) {
  byLocaleSlug.set(`${entry.locale}:${entry.slug}`, entry);
  if (!byId.has(entry.id)) byId.set(entry.id, new Map());
  byId.get(entry.id)!.set(entry.locale, entry);
}

export function getPage(locale: Locale, slugParts: string[]): PageEntry | undefined {
  return byLocaleSlug.get(`${locale}:${slugParts.join("/")}`);
}

/** The full entry for a canonical id in one locale — used by nav rendering,
 * which needs both the href (via slug) and a label (via seo.navLabel/title). */
export function getPageById(id: string, locale: Locale): PageEntry | undefined {
  return byId.get(id)?.get(locale);
}

/** Every locale a canonical page id exists in, mapped to that locale's slug. */
export function alternates(id: string): Partial<Record<Locale, string>> {
  const m = byId.get(id);
  if (!m) return {};
  const out: Partial<Record<Locale, string>> = {};
  for (const [locale, entry] of m) out[locale] = entry.slug;
  return out;
}

/** Static params for the generic [...slug] dispatcher, one locale at a time.
 * Excludes homepages (slug === ""), which have their own route. */
export function routeParamsFor(locale: Locale): { slug: string[] }[] {
  return ALL.filter((e) => e.locale === locale && e.slug !== "").map((e) => ({
    slug: e.slug.split("/"),
  }));
}

/** Locales that have a homepage entry at all — drives [locale]/page.tsx's
 * generateStaticParams instead of a hardcoded list. */
export function homepageLocales(): Locale[] {
  return [...new Set(ALL.filter((e) => e.type === "homepage").map((e) => e.locale))];
}

/** Every registered page, for sitemap generation. */
export function allEntries(): readonly PageEntry[] {
  return ALL;
}
